import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../utils/axios";

const BASE = "/api/v1/erp/grns";

export const fetchGRNs = createAsyncThunk("grn/fetchGRNs", async (params?: string): Promise<any> => {
  const query = params ? `?${params}` : "";
  const response = await axios.get(`${BASE}${query}`);
  return response.data;
});

export const fetchGRNById = createAsyncThunk("grn/fetchGRNById", async (id: string): Promise<any> => {
  const response = await axios.get(`${BASE}/${id}`);
  return response.data;
});

export const addGRN = createAsyncThunk("grn/addGRN", async (payload: any): Promise<any> => {
  const response = await axios.post(BASE, payload);
  return response.data;
});

export const updateGRN = createAsyncThunk("grn/updateGRN", async ({ id, payload }: any): Promise<any> => {
  const response = await axios.put(`${BASE}/${id}`, payload);
  return response.data;
});

export const postGRN = createAsyncThunk("grn/postGRN", async (id: string): Promise<any> => {
  const response = await axios.post(`${BASE}/${id}/post`);
  return response.data;
});

export const cancelGRN = createAsyncThunk("grn/cancelGRN", async (id: string): Promise<any> => {
  const response = await axios.post(`${BASE}/${id}/cancel`);
  return response.data;
});

export const reverseGRN = createAsyncThunk("grn/reverseGRN", async (id: string): Promise<any> => {
  const response = await axios.post(`${BASE}/${id}/reverse`);
  return response.data;
});

// Purchase-invoice picker (server-side search; no term -> latest 10).
export const fetchPurchaseInvoicesForGRN = createAsyncThunk(
  "grn/fetchPurchaseInvoicesForGRN",
  async (search?: string): Promise<any> => {
    const query = search ? `?search=${encodeURIComponent(search)}` : "";
    const response = await axios.get(`${BASE}/purchase-invoices${query}`);
    return response.data;
  }
);

// A purchase invoice's stock-tracked lines shaped as GRN item rows.
export const fetchPurchaseInvoiceLines = createAsyncThunk(
  "grn/fetchPurchaseInvoiceLines",
  async (invoiceId: string): Promise<any> => {
    const response = await axios.get(`${BASE}/purchase-invoices/${invoiceId}/lines`);
    return response.data;
  }
);
